import { FETCH_WEIGHT_DISPUTE_IMAGE_FAILURE, FETCH_WEIGHT_DISPUTE_IMAGE_REQUEST, FETCH_WEIGHT_DISPUTE_IMAGE_RESET, FETCH_WEIGHT_DISPUTE_IMAGE_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getWeightDisputeImageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WEIGHT_DISPUTE_IMAGE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_WEIGHT_DISPUTE_IMAGE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_WEIGHT_DISPUTE_IMAGE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_WEIGHT_DISPUTE_IMAGE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getWeightDisputeImageReducer;
